var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TimeSeries", {
    attrs: { title: "Combined Metrics Trends", loading: _vm.loading },
    scopedSlots: _vm._u([
      {
        key: "graphic",
        fn: function() {
          return [
            _c("CombinedMetricsGraphic", {
              ref: "graphic",
              attrs: {
                series: _vm.series,
                "chart-options": _vm.chartOptions,
                "is-hovered": _vm.isHovered,
                "zoom-enabled": _vm.zoomEnabled
              },
              on: { hover: _vm.handleHover, "enable-zoom": _vm.enableZoom }
            })
          ]
        },
        proxy: true
      },
      {
        key: "analysis",
        fn: function() {
          return [
            _c("CombinedMetricsAnalysis", {
              attrs: {
                "ai-insights": _vm.aiInsights,
                "ai-summary": _vm.aiSummary,
                "ai-insights-error": _vm.aiInsightsError,
                "ai-summary-loading": _vm.aiSummaryLoading,
                "detailed-analysis-loading": _vm.detailedAnalysisLoading,
                "flow-events": _vm.flowEvents,
                "zoom-enabled": _vm.zoomEnabled
              },
              on: {
                "retry-analysis": _vm.retryAIAnalysis,
                "investigate-points": _vm.investigateAIPoints
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fc0733c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc0733c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/AICards/TimeSeriesCard/CombinedMetrics/CombinedMetrics.vue
// module id = null
// module chunks = 